import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { RouterModule } from '@angular/router';

import { ReportComponent } from './components/report.component';
import { ReportMainComponent } from './components/report-main.component';
import { ReportPapersComponent } from './components/report-papers.component';
import { ReportPartsComponent } from './components/report-parts.component';
import { ReportSummaryComponent } from './components/report-summary.component';
import { ReportReviewComponent } from './components/report-review.component';
import { SharedModule } from "../../shared/shared.module";
import { PaperTemplateModule } from '../../shared/modules/paper-template.module';
import { ChartsModule } from 'ng2-charts';

@NgModule({
  imports: [
    RouterModule,
    BrowserModule,
    ChartsModule,
    FormsModule,
    SharedModule,
    PaperTemplateModule
  ],
  declarations: [ReportComponent,
    ReportMainComponent,
    ReportPapersComponent,
    ReportPartsComponent,
    ReportSummaryComponent,
    ReportReviewComponent,

    ]
})
export class ReportModule { }



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/report/report.module.ts